<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Relatório de Fechamento</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="mes">Mês</label>
                  <select class="form-control" v-model="dados.mes">
                    <option value = '01'>Janeiro</option>
                    <option value = '02'>Fevereiro</option>
                    <option value = '03'>Março</option>
                    <option value = '04'>Abril</option>
                    <option value = '05'>Maio</option>
                    <option value = '06'>Junho</option>
                    <option value = '07'>Julho</option>
                    <option value = '08'>Agosto</option>
                    <option value = '09'>Setembro</option>
                    <option value = '10'>Outubro</option>
                    <option value = '11'>Novembro</option>
                    <option value = '12'>Dezembro</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="ano">Ano</label>
                  <select class="form-control" v-model="dados.ano">
                    <option value = '2019'>2019</option>
                    <option value = '2020'>2020 </option>
                    <option value = '2021'>2021 </option>
										<option value = '2022'>2022 </option>
										<option value = '2023'>2023 </option>
										<option value = '2024'>2024</option>
										<option value = '2025'>2025</option>
                    <option value = '2026'>2026</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="empresa">Empresa</label>
                  <v-select v-model="empresaSelecionada" :options="empresas"></v-select>
                </div>
              </div>
              <div class="col-sm-2">
                  <br/>
                  <button @click="gerarRelatorio" style="margin-top: 0.3em;" class="form-group btn btn-primary"><i class="fa fa-print"></i> Gerar</button>
              </div>
            </div>
            <div v-if="showRelatorio" class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive" v-html="htmlRelatorioFechamento">

              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import vSelect from "vue-select";

export default {
  data: () => ({
    showRelatorio: false,
    empresaSelecionada: null,
    empresas: [],
    dados: {
      mes: '01',
      ano: 2022,
      empresa_id: null,
    },
    htmlRelatorioFechamento: ''
  }),
  mounted() {
    this.getEmpresas();
  },

  methods: {
    gerarRelatorio() {
      let config = this.$store.getters.getHeaderAuth;
				config.params = this.dados;
        axios
        .get(
          `${this.$store.state.serverURI}/api/relatorio/getFechamento`,
          config
        )
        .then(response => {
          console.log(response.data);
          this.htmlRelatorioFechamento = response.data;
         });
        this.showRelatorio = true;
    },
    getEmpresas() {
       axios
        .get(
          `${this.$store.state.serverURI}/api/empresa/dataForSelect`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          console.log(response.data);
          this.empresas = response.data;
        });
    }
  },
  watch: {
    empresaSelecionada: function(val) {
      this.dados.empresa_id = val.value;
    }
  },

  components: {
      vSelect
  }
};
</script>
<style>
td {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// index.vue?d5c0cb34